module.exports = __webpack_public_path__ + "static/img/thumb_12.238abda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_12.png
// module id = +GRu
// module chunks = 0